var Vendd = (function (Vendd) {
    'use strict';

    var model = JSON.parse(localStorage.getItem("CurrentDeliveryPointModel"));
    var pending = false;

    Vendd.MessageBus.subscribe(Vendd.DeliveryPoint.Messages.GetModel, Vendd.DeliveryPoint, function (envelope) {

        if (pending === true) {
            return false;
        };

        var options = {
            url: 'api/DeliveryPoint/GetDeliveryPointWidgetModel',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            model = response;
            localStorage.setItem('CurrentDeliveryPointModel', JSON.stringify(model));
            Vendd.MessageBus.publishAsync(Vendd.DeliveryPoint, new Vendd.DeliveryPoint.Messages.GetModelSuccess(response));
            pending = false;
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.DeliveryPoint, new Vendd.DeliveryPoint.Messages.GetModelFailed(response));
            pending = false;
        };

        var cookieDeliveryPointId = LhApp.Function.QueryString.getValueOf("deliverypointid", "?" + Cookies.get("VisitorState")) || 0;
        var localStorageDeliveryPointId = (((model || {}).data || {}).DeliveryPoint || {}).Id || 0;

        if (model != null && model != undefined && document.cookie.indexOf('ForceClearDeliveryPointLocalStorage') == -1 && cookieDeliveryPointId == localStorageDeliveryPointId) {
            Vendd.MessageBus.publishAsync(Vendd.DeliveryPoint, new Vendd.DeliveryPoint.Messages.GetModelSuccess(model));
            return true;
        }

        Cookies.remove('ForceClearDeliveryPointLocalStorage', { path: '/' });
        pending = true;
        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.DeliveryPoint.Messages.ResetStore, Vendd.DeliveryPoint, function (envelope) {

        if (pending === true) {
            return false;
        };

        var options = {
            url: 'checkoutservice.svc/SetStore',
            data: {
                data: "",
                arguments: JSON.stringify({
                    "Id": null
                })
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            model = response;
            localStorage.removeItem('CurrentDeliveryPointModel');
            Vendd.MessageBus.publishAsync(Vendd.DeliveryPoint, new Vendd.DeliveryPoint.Messages.ResetStoreSuccess(response));
            pending = false;
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.DeliveryPoint, new Vendd.DeliveryPoint.Messages.ResetStoreFailed(response));
            pending = false;
        };
        
        pending = true;
        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.DeliveryPoint.Messages.ResetDeliveryPoint, Vendd.DeliveryPoint, function (envelope) {

        if (pending === true) {
            return false;
        };

        var options = {
            url: 'api/DeliveryPoint/SetDeliveryPoint',
            data: {
                deliveryPointId: 1 // Set Deivery Point -> fromSite
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            model = response;
            Vendd.MessageBus.publishAsync(Vendd.DeliveryPoint, new Vendd.DeliveryPoint.Messages.ResetDeliveryPointSuccess(response));
            pending = false;
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.DeliveryPoint, new Vendd.DeliveryPoint.Messages.ResetDeliveryPointFailed(response));
            pending = false;
        };

        pending = true;
        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});
